import { Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { ReactElement, forwardRef } from 'react';

export const TransitionUp = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
